import React, { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import api from '../../lib/api';
import { Loader2 } from 'lucide-react';

/**
 * Opens (in a NEW TAB) the selected seller's OWN existing page, scoped to that
 * seller, via an admin-authorised impersonation token stored in sessionStorage
 * (per-tab only — the admin's real session in other tabs is never touched).
 */
export default function SellerImpersonateBootstrap() {
  const { vid } = useParams();
  const [sp] = useSearchParams();
  const [err, setErr] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; ran.current = true;
    const to = sp.get('to') || '/dashboard';
    (async () => {
      try {
        // Uses the admin's own token (localStorage) for THIS call, before the
        // impersonation token is installed.
        const { data } = await api.post(`/admin/vendors/${vid}/impersonate`);
        sessionStorage.setItem('fab_imp_token', data.token);
        sessionStorage.setItem('fab_imp_name', data.business_name || 'Seller');
        window.location.replace(to);
      } catch (e) {
        setErr(e?.response?.data?.detail || 'Could not open seller view.');
      }
    })();
  }, [vid, sp]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-fab-bg" data-testid="seller-impersonate-bootstrap">
      {err ? (
        <div className="text-center">
          <div className="text-red-600 font-semibold mb-2" data-testid="impersonate-error">{err}</div>
          <button onClick={() => window.close()} className="text-fab-primary underline text-sm">Close</button>
        </div>
      ) : (
        <div className="flex items-center gap-2 text-fab-text-secondary">
          <Loader2 className="w-5 h-5 animate-spin" /> Opening seller view…
        </div>
      )}
    </div>
  );
}
